import apiClient from '../../../services/apiClient';
import { exportData } from '../../../utils/exportData';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';

const ApiClient = async (method, route, data = {}) => {
  try {
    let response;
    if (method === 'post') {
      response = await apiClient.post(route, data);
    } else if (method === 'get') {
      response = await apiClient.get(route, { params: data });
    } else if (method === 'put') {
      response = await apiClient.put(route, data);
    }
    console.log('data', response);
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error;
  }
};
export const importProducts = async (formData) => {
  try {
    const response = await apiClient.post('/products/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('data', response);

    showSuccessToast(response?.data?.message || '');
    return response.data;
  } catch (error) {
    console.log('error', error);
    showErrorToast(error?.message || 'An unexpected error occurred.');
    return error.data;
  }
};
export const checkImportProgress = async (query) => {
  return await ApiClient('get', '/products/import-progress', query);
};
// export const exportProducts = async (data) => {
//   return await ApiClient("post", "/products/export", data);
// };
export const productBulkAction = async (data) => {
  return await ApiClient('post', '/products/change-fbz', data);
};
export const addProduct = async (data) => {
  return await ApiClient('post', '/products', data);
};
export const updateProduct = async (data, product_id) => {
  return await ApiClient('put', '/products/' + product_id, data);
};

export const fetchProducts = async (query) => {
  return await ApiClient('get', '/products', query);
};
export const searchRelatedProducts = async (query) => {
  return await ApiClient('get', '/products/search-related-product', query);
};

export const fetchProductsCategories = async () => {
  return await ApiClient('get', '/products/categories', { per_page: 1000 });
};
export const fetchProcessCategories = async () => {
  return await ApiClient('get', '/master/process-category', { per_page: 1000 });
};
export const fetchProductsUnits = async () => {
  return await ApiClient('get', '/master/product-unit', { per_page: 1000 });
};
export const fetchSpecificationUnits = async () => {
  return await ApiClient('get', '/master/specification-unit', {
    per_page: 1000,
  });
};
export const fetchProcessLocations = async () => {
  return await ApiClient('get', '/master/process-location', { per_page: 1000 });
};
export const fetchOrigins = async () => {
  return await ApiClient('get', '/master/origin', { per_page: 1000 });
};
export const generateProductCode = async () => {
  return await ApiClient('get', 'products/generate-code');
};
export const exportProducts = async (filters, fileName) => {
  return await exportData('/products/export', filters, fileName);
};

// export const getUsersWithPermissions = async () => {
//     return await ApiClient('get','/users')
// };
// export const registerUser = async (data) => {
//     return await ApiClient('post','/auth/register', data)
// };
// export const updatePermissions = async (data) => {
//     return await ApiClient('put','/permissions', data)
// };
